export const toCapitalize = value =>
  `${value[0].toUpperCase()}${value.substring(1)}`;



// WEBPACK FOOTER //
// ./src/utils/toCapitalize.js